import type { RecommendationPlacement, RecommendationPosition, PlacementSetting } from '@parentpath/supabase-client';

export const PLACEMENT_LABELS: Record<RecommendationPlacement, string> = {
  ssw_content: 'SSW-Inhalt',
  baby_development: 'Baby-Entwicklung',
  checklist_detail: 'Checklisten-Details',
  wissenswertes_pregnancy: 'Wissenswertes (Schwangerschaft)',
  wissenswertes_baby: 'Wissenswertes (Baby)',
};

export const PLACEMENT_OPTIONS: RecommendationPlacement[] = [
  'ssw_content',
  'baby_development',
  'checklist_detail',
  'wissenswertes_pregnancy',
  'wissenswertes_baby',
];

export const PLACEMENT_DEFAULTS: Record<RecommendationPlacement, PlacementSetting> = {
  ssw_content: { variant: 'compact', position: 'before_text' },
  baby_development: { variant: 'compact', position: 'after_milestones' },
  checklist_detail: { variant: 'compact', position: 'random' },
  wissenswertes_pregnancy: { variant: 'extended', position: 'random' },
  wissenswertes_baby: { variant: 'extended', position: 'random' },
};

export const VARIANT_LABELS: Record<'extended' | 'compact', string> = {
  extended: 'Extended',
  compact: 'Compact',
};

export const POSITION_OPTIONS_BY_PLACEMENT: Record<RecommendationPlacement, { value: RecommendationPosition; label: string }[]> = {
  ssw_content: [
    { value: 'end', label: 'Am Ende' },
    { value: 'before_text', label: 'Vor Fließtext' },
  ],
  baby_development: [
    { value: 'end', label: 'Am Ende' },
    { value: 'after_milestones', label: 'Nach Meilensteine' },
  ],
  checklist_detail: [
    { value: 'end', label: 'Am Ende' },
    { value: 'random', label: 'Zufällig' },
  ],
  wissenswertes_pregnancy: [
    { value: 'end', label: 'Am Ende' },
    { value: 'random', label: 'Zufällig' },
    { value: 'start', label: 'Am Anfang' },
  ],
  wissenswertes_baby: [
    { value: 'end', label: 'Am Ende' },
    { value: 'random', label: 'Zufällig' },
    { value: 'start', label: 'Am Anfang' },
  ],
};
